import { render, staticRenderFns } from "./CurrencyTicker.vue?vue&type=template&id=473ccc69&scoped=true&"
import script from "./CurrencyTicker.vue?vue&type=script&lang=js&"
export * from "./CurrencyTicker.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyTicker.vue?vue&type=style&index=0&id=473ccc69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ccc69",
  null
  
)

export default component.exports